import classNames from "classnames";

import { DetailsContent } from "components/app_layout/DetailsLayout";
import { PaywallContent } from "./PaywallContent";
import { FeatureType, PaywallImg } from "./paywallUtils";

import css from "./PaywallBanner.module.scss";

type BannerProps = { featureType?: FeatureType; className?: string };

export function PaywallBanner({ featureType, className }: BannerProps): JSX.Element | null {
  if (!featureType) {
    return null;
  }

  return (
    <DetailsContent className={classNames(css.banner, className)}>
      <div className={css.bannerContainer} data-testid="details-content" role="banner">
        <PaywallContent featureType={featureType} />
        <PaywallImg context={"BANNER"} featureType={featureType} />
      </div>
    </DetailsContent>
  );
}
